<div class="side-menu-container">
  @if (isMobile && openedRotina && moduloSelecionado && moduloSelecionado.rotinas?.length > 1) {
    <div class="shadow-unic">
      <div class="center-center width-100">
        <div class="mobile-top-tabs flex-direction-row gap-10 padding-10 bg-light-purple flex-wrap">
          @for (rotina of moduloSelecionado.rotinas; track rotina.id) {
            <div class="center-center flex-direction-column gap-5">
              <div class="rotina-tab padding-8 border-radius-6 cursor-pointer"
                   role="button"
                   tabindex="0"
                   (click)="selectRotina(rotina)"
                   (keydown.enter)="selectRotina(rotina)"
                   [ngClass]="rotinaSelecionada?.id === rotina.id ? 'rotina-selecionada' : ''"
                   [routerLink]="rotina.url">
              </div>
              <span class="weight-400 font-11" style="color: black;">{{ rotina.nome }}</span>
            </div>
          }
        </div>
      </div>
      <ng-container *ngTemplateOutlet="menu"></ng-container>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="menu"></ng-container>
  }
</div>

<ng-template #menu>
  <div class="menu gap-10 justify-between"
    [ngClass]="{
      'flex-direction-row mobile-menu': isMobile && !opened,
      'flex-direction-column': !isMobile,
      'mobile-open': isMobile && (opened || openedRotina)
    }"
    [ngStyle]="{'width': (!isMobile && opened) ? '200px' : '', 'box-shadow': (isMobile && openedRotina && moduloSelecionado?.rotinas?.length > 1) ? '0' : '1px 2px 10px #00000057'}">
    <div [ngClass]="isMobile ? 'flex-direction-row gap-20 justify-between width-100' : 'flex-direction-column gap-15 width-100'">
      @if (!isMobile) {
        <div class="flex-direction-row gap-5 center-center">
          @if (!opened) {
            <img src="/favicon.ico" alt="Clari Icon" style="width: 30px" />
          }
          @if (opened) {
            <img src="./assets/clari-talk-logo-texto.png" alt="Logo Title" style="width: 103px;"/>
          }
        </div>
        <div class="divider" style="margin-top: -5px"></div>
      }

      <div class="flex-direction-row gap-10 align-center color-cinza cursor-pointer"
           role="button"
           tabindex="0"
           routerLink="/index"
           (click)="opened = false; moduloSelecionado = null; rotinaSelecionada = null; setMenuOpen(false)"
           (keydown.enter)="opened = false; moduloSelecionado = null; rotinaSelecionada = null; setMenuOpen(false)"
           [ngClass]="moduloSelecionado === null ? (isMobile ? 'modulo-selecionado no-bg-selected' : 'modulo modulo-selecionado') : (isMobile ? 'modulo' : 'modulo')"
           [class.justify-center]="isMobile || !opened">
        <img [src]="iconeModulo('home', moduloSelecionado === null)"
             matTooltip="Home"
             [ngStyle]="moduloSelecionado === null ? {'filter': 'brightness(0) invert(1)'} : {}"
             alt="Home Icon" />
        @if (opened && !isMobile) {
          <span class="font-14 weight-700">Home</span>
        }
      </div>

      @for (modulo of modulos; track modulo.idModulo) {
        <div class="flex-direction-row gap-10 color-cinza align-center cursor-pointer"
             style="margin-bottom: 3px"
             role="button"
             tabindex="0"
             [matTooltip]="modulo.nomeModulo"
             (click)="verificarSeUmaRotina(modulo)"
             (keydown.enter)="verificarSeUmaRotina(modulo)"
             [ngClass]="moduloSelecionado?.idModulo === modulo.idModulo ? (isMobile ? 'modulo-selecionado no-bg-selected' : 'modulo modulo-selecionado') : (isMobile ? 'modulo' : 'modulo')"
             [class.justify-center]="isMobile || !opened">
          <img [src]="iconeModulo(modulo.iconeModulo, moduloSelecionado?.idModulo === modulo.idModulo)"
               style="width: 21px; height: 21px;"
               [ngStyle]="moduloSelecionado?.idModulo === modulo.idModulo ? {'filter': 'brightness(0) invert(1)'} : {}"
               alt="{{ modulo.nomeModulo }} Icon" />
          @if (opened && !isMobile) {
            <span class="font-14 weight-700">{{ modulo.nomeModulo }}</span>
          }
        </div>

        @if (!isMobile && opened && openedRotina && moduloSelecionado?.idModulo === modulo.idModulo && modulo.rotinas?.length > 1) {
          @for (rotina of modulo.rotinas; track rotina.id) {
            <div class="flex-direction-row area-rotina align-center" style="margin-top: -15px">
              @if (rotinaSelecionada?.id === rotina.id) {
                <div class="circulo bg-primary" style="margin-left: -3.5px;"></div>
              }
              <div class="flex align-center rotina padding-8px width-100 cursor-pointer"
                   role="button"
                   tabindex="0"
                   (click)="selectRotina(rotina)"
                   (keydown.enter)="selectRotina(rotina)"
                   [ngClass]="rotinaSelecionada?.id === rotina.id ? 'rotina-selecionada' : ''"
                   [routerLink]="rotina.url"
                   style="margin-left: 2px;">
                <span class="weight-700 font-12">{{ rotina.nome }}</span>
              </div>
            </div>
          }
        }
      }

      @if(isMobile){
        <div class="flex-direction-column gap-10 modulo" [ngClass]="{'width-auto': isMobile}">
          @if (!isMobile) {
            <div class="divider"></div>
          }
          <div class="flex-direction-row gap-5 justify-center align-start color-cinza">
            <img src="./assets/icones/redesign/modulos-rotinas/person.svg"
                 class="cursor-pointer"
                 role="button"
                 tabindex="0"
                 (click)="redirecionar()"
                 (keydown.enter)="redirecionar()"
                 alt="Profile Icon" />
            @if (opened && !isMobile) {
              <div class="flex-direction-column width-100">
                <span class="ellipse font-14 weight-700 color-primary cursor-default"
                      [matTooltip]="usuarioLogado.nome">{{ usuarioLogado.nome }}</span>
                <span class="font-10 weight-700 cursor-pointer color-black"
                      role="button"
                      tabindex="0"
                      (click)="redirecionar()"
                      (keydown.enter)="redirecionar()">Editar</span>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if(!isMobile){
      <div class="flex-direction-column gap-10">
        <div class="divider"></div>
        <div class="flex-direction-row gap-5 justify-center align-start color-cinza">
          <img src="./assets/icones/redesign/modulos-rotinas/person.svg"
               class="cursor-pointer"
               role="button"
               tabindex="0"
               (click)="redirecionar()"
               (keydown.enter)="redirecionar()"
               alt="Profile Icon" />
          @if (opened) {
            <div class="flex-direction-column width-100 center-start" style="align-items: flex-start!important; max-width: 9.2vw;">
              <span class="ellipse font-14 weight-700 color-primary cursor-default"
                    [matTooltip]="usuarioLogado.nome">{{ usuarioLogado.nome }}</span>
              <span class="font-10 weight-700 cursor-pointer color-black"
                    role="button"
                    tabindex="0"
                    (click)="redirecionar()"
                    (keydown.enter)="redirecionar()">Editar</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
